import { useState, useEffect } from "react"
import {
  isLatLngQueryString,
  createGeolocationFeature,
} from "utils/geolocation"
import { useQuery } from "./useQuery"
import {
  get as getPersistValue,
  set as setPersistValue,
} from "utils/persist_store"

const VENUE_DEVICE_LOCATION_KEY = "venue_device_location"

export const useDeviceLocation = () => {
  const [deviceLocationState, setDeviceLocationState] = useState(
    createGeolocationFeature(getPersistValue(VENUE_DEVICE_LOCATION_KEY), {
      name: "Your Location",
    })
  )

  const { deviceLocation } = useQuery()

  useEffect(() => {
    if (deviceLocation && isLatLngQueryString(deviceLocation)) {
      setPersistValue(VENUE_DEVICE_LOCATION_KEY, deviceLocation)
      setDeviceLocationState(
        createGeolocationFeature(getPersistValue(VENUE_DEVICE_LOCATION_KEY), {
          name: "Your Location",
        })
      )
    }
  }, [deviceLocation])

  return {
    deviceLocation: deviceLocationState,
  }
}
